import React, { useState } from "react";
import "./AgentReportPage.css";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import vi from "date-fns/locale/vi";

registerLocale("vi", vi);

const AgentReportPage = () => {
    const [filters, setFilters] = useState({
        tinhThanh: "",
        phuongXa: "",
        fromDate: null,
        toDate: null,
        donViKD: "",
        trangThai: "",
    });

    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleDateChange = (d, name) => {
        setFilters({ ...filters, [name]: d });
    };

    const handleReset = () => {
        setFilters({
            tinhThanh: "",
            phuongXa: "",
            fromDate: null,
            toDate: null,
            donViKD: "",
            trangThai: "",
        });
    };

    // Fake data
    const data = [
        {
            cifChuQuan: "00001234",
            idDLTT: "ID-00001234-068-001",
            cifDLTT: "00007899",
            tenDLTT: "Đại lý Thanh toán Như Ý",
            soGCNDKDN: "DNK-2023-004",
            trangThai: "Hoạt động",
            tktt: "4444444444",
            soNhanVien: 0,
            hanMucNgay: "200,000,000",
            hanMucThang: "5,000,000,000",
            cbnvQL: "03333 - Lê Văn C",
            branchQL: "002 - BVB Hà Nội",
            thoiGianTao: "2025-03-05 09:00:00",
        },
        {
            cifChuQuan: "Content",
            idDLTT: "Content",
            cifDLTT: "Content",
            tenDLTT: "Content",
            soGCNDKDN: "Content",
            trangThai: "Đóng",
            tktt: "Content",
            soNhanVien: "Content",
            hanMucNgay: "Content",
            hanMucThang: "Content",
            cbnvQL: "Content",
            branchQL: "Content",
            thoiGianTao: "Content",
        },
        {
            cifChuQuan: "Content",
            idDLTT: "Content",
            cifDLTT: "Content",
            tenDLTT: "Content",
            soGCNDKDN: "Content",
            trangThai: "Đóng",
            tktt: "Content",
            soNhanVien: "Content",
            hanMucNgay: "Content",
            hanMucThang: "Content",
            cbnvQL: "Content",
            branchQL: "Content",
            thoiGianTao: "Content",
        },
        {
            cifChuQuan: "Content",
            idDLTT: "Content",
            cifDLTT: "Content",
            tenDLTT: "Content",
            soGCNDKDN: "Content",
            trangThai: "Tạm khóa",
            tktt: "Content",
            soNhanVien: "Content",
            hanMucNgay: "Content",
            hanMucThang: "Content",
            cbnvQL: "Content",
            branchQL: "Content",
            thoiGianTao: "Content",
        },
    ];

    return (
        <div className="ar-container">
            <h2 className="page-title">Báo cáo Đại lý thanh toán</h2>

            {/* FILTER FORM */}
            <div className="ar-filter-card">

                <div className="ar-grid">

                    <div className="ar-item">
                        <label>Tỉnh/thành</label>
                        <input
                            name="tinhThanh"
                            value={filters.tinhThanh}
                            onChange={handleChange}
                            placeholder="Nhập tỉnh/thành"
                        />
                    </div>

                    <div className="ar-item">
                        <label>Phường/Xã</label>
                        <select
                            name="phuongXa"
                            value={filters.phuongXa}
                            onChange={handleChange}
                        >
                            <option value="">Chọn phường/xã</option>
                            <option value="p1">Phường 1</option>
                        </select>
                    </div>

                    <div className="ar-item">
                        <label>Từ ngày (From Date)</label>
                        <div className="ar-date-wrapper">
                            <img
                                src="/icons/icons8-calendar-100.png"
                                className="ar-date-icon"
                            />
                            <DatePicker
                                selected={filters.fromDate}
                                onChange={(d) => handleDateChange(d, "fromDate")}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="dd/mm/yyyy"
                                className="ar-datepicker"
                                locale="vi"
                            />
                        </div>
                    </div>

                    <div className="ar-item">
                        <label>Đến ngày (To Date)</label>
                        <div className="ar-date-wrapper">
                            <img
                                src="/icons/icons8-calendar-100.png"
                                className="ar-date-icon"
                            />
                            <DatePicker
                                selected={filters.toDate}
                                onChange={(d) => handleDateChange(d, "toDate")}
                                dateFormat="dd/MM/yyyy"
                                placeholderText="dd/mm/yyyy"
                                className="ar-datepicker"
                                locale="vi"
                            />
                        </div>
                    </div>

                    <div className="ar-item">
                        <label>Đơn vị kinh doanh</label>
                        <input
                            name="donViKD"
                            value={filters.donViKD}
                            onChange={handleChange}
                            placeholder="Nhập đơn vị KD"
                        />
                    </div>

                    <div className="ar-item">
                        <label>Trạng thái</label>
                        <select
                            name="trangThai"
                            value={filters.trangThai}
                            onChange={handleChange}
                        >
                            <option value="">Tất cả</option>
                            <option value="active">Hoạt động</option>
                            <option value="close">Đóng</option>
                            <option value="lock">Tạm khóa</option>
                        </select>
                    </div>
                </div>

                <div className="ar-actions">
                    <button className="btn-secondary" onClick={handleReset}>
                        Xóa lọc
                    </button>
                    <button className="btn-primary">Tìm kiếm</button>
                </div>
            </div>

            {/* RESULT */}
            <h3 className="ar-result-title">Kết quả tìm kiếm</h3>

            <div className="ar-table-wrapper">
                <table className="ar-table">
                    <thead>
                        <tr>
                            <th>CIF Agent chủ quản</th>
                            <th>ID ĐLTT</th>
                            <th>CIF ĐLTT</th>
                            <th>Tên ĐLTT</th>
                            <th>Số GCNDKDN</th>
                            <th>Trạng thái</th>
                            <th>TKTT giao dịch</th>
                            <th>Số lượng nhân viên</th>
                            <th>Hạn mức ngày</th>
                            <th>Hạn mức tháng</th>
                            <th>CBNV quản lý</th>
                            <th>Branch quản lý</th>
                            <th>Thời gian tạo</th>
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((row, i) => (
                            <tr key={i}>
                                <td>{row.cifChuQuan}</td>
                                <td>{row.idDLTT}</td>
                                <td>{row.cifDLTT}</td>
                                <td>{row.tenDLTT}</td>
                                <td>{row.soGCNDKDN}</td>
                                <td>{row.trangThai}</td>
                                <td>{row.tktt}</td>
                                <td>{row.soNhanVien}</td>
                                <td>{row.hanMucNgay}</td>
                                <td>{row.hanMucThang}</td>
                                <td>{row.cbnvQL}</td>
                                <td>{row.branchQL}</td>
                                <td>{row.thoiGianTao}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {/* PAGINATION */}
            <div className="pagination">
                <span>Số lượng bản ghi: 4/10 (trên 10 bản ghi/trang)</span>
                <div className="pager">
                    <button disabled>Trước</button>
                    <button className="active">1</button>
                    <button>Sau</button>
                </div>
            </div>
        </div>
    );
};

export default AgentReportPage;
